import { useCallback, useEffect, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import {
  getInvestorEntryByEmail,
  getInvestorEntryById,
  getSearchableInvestorEntryById,
} from "../../services/investorService";
import { ImportedInvestorEntry } from "../../types/ImportedInvestorEntry";
import { SearchableInvestorEntry } from "../../types/SearchableInvestorEntry";
import "./MappingDebugger.scss";

interface MappingDebuggerProps {}

const MappingDebugger: React.FC<MappingDebuggerProps> = () => {
  const [email, setEmail] = useState("");

  const [searchParams] = useSearchParams();
  const importedInvestorId = searchParams.get("importedInvestorId");

  const [loadedInvestorEntry, setLoadedInvestorEntry] =
    useState<ImportedInvestorEntry | null>(null);
  const [loadedSearchableInvestorEntry, setLoadedSearchableInvestorEntry] =
    useState<SearchableInvestorEntry | null>(null);

  const bindToInvestorEntry = useCallback(
    async (investorEntry: ImportedInvestorEntry | null) => {
      if (investorEntry?.searchableInvestorEntryId) {
        const searchableInvestorEntry = await getSearchableInvestorEntryById(
          investorEntry.searchableInvestorEntryId,
        );
        setLoadedSearchableInvestorEntry(searchableInvestorEntry);
      }
    },
    [],
  );

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const investorEntry = await getInvestorEntryByEmail(email);
      setLoadedInvestorEntry(investorEntry);
      bindToInvestorEntry(investorEntry);
    },
    [bindToInvestorEntry, email],
  );

  const fetchInvestorEntry = useCallback(
    async (importedInvestorId: string) => {
      const investorEntry = await getInvestorEntryById(importedInvestorId);
      setLoadedInvestorEntry(investorEntry);
      bindToInvestorEntry(investorEntry);
    },
    [bindToInvestorEntry],
  );

  useEffect(() => {
    if (importedInvestorId) {
      fetchInvestorEntry(importedInvestorId);
    }
  }, [fetchInvestorEntry, importedInvestorId]);

  return (
    <div className="mapping-debugger">
      <div className="mapping-debugger-header">Mapping Debugger</div>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email address to debug"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <div className="mapping-debugger-data">
          {!loadedInvestorEntry && !loadedSearchableInvestorEntry && (
            <Alert variant="info">
              No data loaded. Please enter an email address to load data.
            </Alert>
          )}
          {loadedInvestorEntry && (
            <pre>{JSON.stringify(loadedInvestorEntry, null, 2)}</pre>
          )}
          {loadedSearchableInvestorEntry && (
            <pre>{JSON.stringify(loadedSearchableInvestorEntry, null, 2)}</pre>
          )}
        </div>
      </Form>
    </div>
  );
};

export default MappingDebugger;
